
const rotateCanvas90CW = (canvas) => {
    const rotCanvas = new OffscreenCanvas(canvas.height, canvas.width);
    const rotCtx = rotCanvas.getContext('2d');
    rotCtx.translate(rotCanvas.width / 2, rotCanvas.height / 2);
    rotCtx.rotate(Math.PI / 2);
    rotCtx.drawImage(canvas, -rotCanvas.height / 2, -rotCanvas.width / 2);
    return rotCanvas;
};

const TEXT_SIZE_RATIO = .68;
const TOP_TEXT_OFFSET = .50;
const BOTTOM_TEXT_OFFSET = .96;

export default {
    
    generateLabel: async (LabelText, middleText, bottomText, length, width, rotate) => {
        return new Promise ((resolve, reject) => {
            console.log("Not using middleText: %s or bottomText: %s", middleText, bottomText);
            const TopTextHeight = length * TOP_TEXT_OFFSET;
            const BottomTextHeight = length * BOTTOM_TEXT_OFFSET;
            const textSize = length * TEXT_SIZE_RATIO;
            const font = `bold ${textSize}px Courier New`;
            const line1 = LabelText.substring(0, 3);
            const line2 = LabelText.substring(3, 6);

            var canvas = new OffscreenCanvas(width, length);
            const ctx = canvas.getContext('2d');
            
            ctx.font = font;
            ctx.fillStyle = 'white';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.fillStyle = 'black';
            ctx.textAlign = "left";

            ctx.fillText(line1, length * .01, TopTextHeight);
            ctx.fillText(line2, length * .01, BottomTextHeight);

            if (rotate) {
                canvas = rotateCanvas90CW(canvas);
            }

            canvas.convertToBlob()
            .then(blob => {
                resolve(blob);
            }).
            catch(err => {
                reject(err);
            });
        });
    }
};